import { toNestErrors } from "@hookform/resolvers";
import { FieldError, ResolverResult } from "react-hook-form";
import vest from "vest";

export type VestSchema = ReturnType<typeof vest.create>;

export type FormValidationContext<
  FormValues = Record<string, any>,
  ExtraData = never
> = {
  initialValues: FormValues;
} & ([ExtraData] extends [never] ? {} : { extraData: ExtraData });

// Have to write a somewhat complex custom resolver because the default
// doesnt support our idea of "context" which is used in the form
// to pass extra data to the validation schema
export const vestResolver =
  (schema: VestSchema) =>
  async (
    values: Record<string, any>,
    context?: Record<string, any>
  ): Promise<ResolverResult> => {
    const result = schema(values, context);
    const hasErrors = result.hasErrors();
    if (!hasErrors)
      return {
        values,
        errors: {}
      };

    const vestErrors = result.getErrors();
    const errors: Record<string, FieldError> = {};
    Object.keys(vestErrors).forEach((path) => {
      if (!errors[path]) {
        errors[path] = { message: vestErrors[path][0], type: "" };
      }
    });

    return {
      values: {},
      errors: toNestErrors(errors, {
        fields: {},
        shouldUseNativeValidation: false
      })
    };
  };
